import React from "react";
import { Text } from "@sitecore-jss/sitecore-jss-react";
import classnames from "classnames";
import NavButton from "../NavButton";
import { useTranslation } from "react-i18next";
import { log } from "@assets/js/utils";

import dataLayerPush from "@assets/js/gtm";
import { DATALAYER_EVENTS } from "@constants";
import useGlobalStore from "@store/global";

import "./newsletter-signup.scss";

const NewsletterSignUp = ({ fields }) => {
  const classList = classnames({
    "newsletter-signup": true,
    "newsletter-signup--inverted": fields?.isInverted?.value,
  });
  
  if(fields?.link?.value){
    fields.link.value.target = "_blank";
  }

  const button = {
    fields: {
      hasArrow: {
        value: false,
      },
      isInverted: {
        value: false,
      },
      style: {
        value: "ghost",
      },
      link: fields?.link,
    },
  };

  return (
    <div className={classList}>
      {fields?.headline?.value && (
        <Text
          tag="h2"
          className="newsletter-signup__headline"
          field={fields?.headline}
        />
      )}
      {fields?.bodyText?.value && (
        <Text
          tag="p"
          className="newsletter-signup__bodytext"
          field={fields?.bodyText}
        />
      )}
      <div className="newsletter-signup__button">
        <NavButton fields={button.fields} clickHandler={(text, url) => {
          let obj = {
            event: DATALAYER_EVENTS.NAVIGATION,
            navigationType: "footer navigation",
            navigationMenuPoint: text,
            navigationDestination: url
          }

          log("newsletterSignup.clickHandler", obj);
          // Tracking
          dataLayerPush(obj);
        }} />
      </div>
    </div>
  );
};

export default NewsletterSignUp;
